import logo from './assets/logo.png';
import illustration from './assets/ilus.png';

interface IStartCoverProps {
    clientName: string;
}

const StartCover = (props: IStartCoverProps) => {

    const {clientName} = props;
    const date = `${new Date().toLocaleString('default', {month: 'long'})} ${new Date().getFullYear()}`;

    return (
        <article className="start-cover">
            <div className="section-1 with-margin">
                <h3>MILLIMAN REPORT</h3>
                <h1>{clientName}</h1>
                <h1>Network Analysis</h1>
                <h2>Network Adequacy Report for Primary Service Area</h2>
                <h4>{date}</h4>
                {/* <div>
                    <p>John Kasey, MHA</p>
                    <p>Stefany Ross, MHA</p>
                    <p>Gordon Chan, MHA</p>
                    <p>Adam Hearn, MS-DSPP</p>
                </div> */}
            </div>
            <div className="section-2">
                <div className='illustration'>
                    <img src={illustration} alt="Network Illustration" />
                </div>
                <div className="logo with-margin">
                    <img src={logo} alt="Milliman Logo" />
                </div>
            </div>
        </article>
    );
};

export default StartCover;
